module.exports = __webpack_public_path__ + "static/media/clear.5b488f43.ico";